import { reloadUserSettings } from 'lib/redux/users/slice';
import { reloadAuthorizationInfoInitialState, reloadTeam, reloadUser, reloadVisibleAccounts } from 'lib/redux/users/slice';
import React, { useEffect } from 'react';
import { RootState } from 'store';
import { useSelector, useDispatch } from 'react-redux';
import { Loader } from 'components/Loader';

// Define the types for the props
interface PrivateRouteProps {
    onlyLoadAuthenticationInfo?: boolean;
    onlyProgressOnAuthenticationLoad?: boolean;
    component: React.ComponentType<any>;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, onlyLoadAuthenticationInfo, onlyProgressOnAuthenticationLoad }: PrivateRouteProps) => {
    // Use direct Redux selectors for loading logic to avoid circular dependencies with useUserData hook
    const user = useSelector((state: RootState) => state.user.value);
    const visibleAccounts = useSelector((state: RootState) => state.visibleAccounts.value);
    const authentication_info = useSelector((state: RootState) => state.authenticationInfo.value);
    const userSettings = useSelector((state: RootState) => state.settings.value);
    const team = useSelector((state: RootState) => state.team.value);
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (!authentication_info) { 
            reloadAuthorizationInfoInitialState(dispatch);
        }
    }, [authentication_info, dispatch]);

    useEffect(() => {
        if (!onlyLoadAuthenticationInfo && !user) {
            reloadUser(dispatch);
        }
    }, [onlyLoadAuthenticationInfo, user, dispatch]);

    useEffect(() => {
        if (!onlyLoadAuthenticationInfo && userSettings === null) {
            reloadUserSettings(dispatch);
        }
    }, [onlyLoadAuthenticationInfo, userSettings, dispatch]);

    useEffect(() => {
        if (!onlyLoadAuthenticationInfo && !visibleAccounts) {
            reloadVisibleAccounts(dispatch);
        }
    }, [onlyLoadAuthenticationInfo, visibleAccounts, dispatch]);

    useEffect(() => {
        if (!onlyLoadAuthenticationInfo && !team) {
            reloadTeam(dispatch);
        }
    }, [onlyLoadAuthenticationInfo, team, dispatch]);
    if (onlyProgressOnAuthenticationLoad && !authentication_info) return <Loader />

    return <Component authentication_info={authentication_info} user={user} visibleAccounts={visibleAccounts} userSettings={userSettings} team={team} dispatch={dispatch} />;
};

export { PrivateRoute as ExtensionPageWrap}